import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: (p) => p.spacing(3),
};

export const emptyIcon: SxStyle = {
  backgroundColor: (p) => p.palette.common.white,
  color: (p) => p.palette.grey[400],
};

export const emptyIconWrapper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
};

export const notFoundTitleWrapper: SxStyle = {
  display: 'flex',
  textAlign: 'center',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(1.5, 2),
  borderRadius: (p) => p.spacing(1),
  background: (p) => p.palette.common.white,
  width: (p) => p.spacing(33),
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
  color: (p) => p.palette.grey[500],
};
